'use client';

import { AnimatePresence, checkIsNative, cn, Div } from '@scatterlab/zeta-core';
import { FC, memo, useEffect, useState } from 'react';

import ToastItem from './ToastItem';
import toast, { Toast } from './toastManager';

const Toaster: FC = () => {
  const [topToasts, setTopToasts] = useState<Toast[]>([]);
  const [bottomToasts, setBottomToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const removeListeners = [
      toast.addEventListener('add', (newToast) => {
        if (newToast.position === 'top')
          setTopToasts((prev) => [...prev, newToast]);
        else setBottomToasts((prev) => [...prev, newToast]);
      }),

      toast.addEventListener('remove', (id) => {
        setTopToasts((prev) => prev.filter((item) => item.id !== id));
        setBottomToasts((prev) => prev.filter((item) => item.id !== id));
      }),
    ];

    return () => {
      removeListeners.forEach((remove) => remove());
    };
  }, []);

  return (
    <>
      <Div
        className={cn(
          'fixed inset-x-0 top-4 z-50 mx-4 flex flex-col items-center gap-4',
          !checkIsNative() && 'pointer-events-none',
        )}
        pointerEvents="box-none"
      >
        <AnimatePresence>
          {topToasts.map((props) => (
            <ToastItem key={props.id} {...props} />
          ))}
        </AnimatePresence>
      </Div>
      <Div
        className={cn(
          'fixed inset-x-0 bottom-4 z-[60] mx-4 flex flex-col items-center gap-4',
          !checkIsNative() && 'pointer-events-none',
        )}
        pointerEvents="box-none"
      >
        <AnimatePresence>
          {bottomToasts.map((props) => (
            <ToastItem key={props.id} {...props} />
          ))}
        </AnimatePresence>
      </Div>
    </>
  );
};

export default memo(Toaster);
